<template>
  <!-- ⭐ Create Dialog ⭐ -->
  <el-dialog
    id="create-modal"
    class="form-modal"
    :visible.sync="createVisible"
    :fullscreen="true"
    :show-close="false"
    :modal="false"
    v-loading="createProcessing"
  >
    <div id="create-modal-header" class="modal-header">
      <div class="modal-header-layout flex grid-6 align-center">
        <h1 class="modal-title col-2">Create {{ techType === 'sms' ? 'SMS' : 'Call'}} Campaign</h1>
        <div class="modal-actions col-2">
          <el-button type="primary" @click="createOperation">
            Create
          </el-button>
          <el-button
            type="default"
            class="hidden-xs-only"
            @click="cancelOperation"
          >
            Cancel
          </el-button>
          <el-button
            type="default"
            icon="el-icon-close"
            class="hidden-sm-and-up"
            @click="cancelOperation"
          />
        </div>
      </div>
    </div>

    <div class="dialog__body">
      <el-form>
        <el-tabs v-model="activeTabName">
          <!-- GENERAL -->
          <el-tab-pane label="General" name="general">
            <div v-if="techType === 'voice'">
              <el-checkbox v-model="voiceForm.recording"
                >Always record</el-checkbox
              >
            </div>

            <div class="inline-form-group">
              <el-col :span="12">
                <el-input
                  type="text"
                  v-model="form.name"
                  placeholder="Enter name"
                >
                  <template slot="prefix">Name</template>
                </el-input>
              </el-col>
              <el-col :span="1" />
              <el-col :span="11">
                <el-select v-model="form.state" placeholder="Select state">
                  <el-option
                    v-for="state in stateOptions"
                    :key="state"
                    :label="state"
                    :value="state"
                  />
                  <template slot="prefix">State</template>
                </el-select>
              </el-col>
            </div>

            <!-- COMMON FIELDS -->
            <div class="inline-form-group">
              <el-col :span="12">
                <dads-select
                  v-model="form.timezone"
                  placeholder="Select a time zone"
                  filterable
                >
                  <template slot="prefix">Time zone</template>
                  <el-option label="Use account default" value="" />
                  <el-option
                    v-for="(timezone, index) in timezoneOpts"
                    :key="index"
                    :label="timezone.name"
                    :value="timezone.name"
                  />
                </dads-select>
              </el-col>
              <el-col :span="1" />
              <el-col :span="11">
                <dads-select
                  v-model="form.callerId"
                  placeholder="Select caller id"
                  remote
                  filterable
                  clearable
                  :remote-method="remoteSearchPhoneNumbers"
                >
                  <el-option
                    v-for="(item, index) in phoneNumberOpts"
                    :key="index"
                    :label="numberFormatter(item.number)"
                    :value="item.number"
                  />
                  <template slot="prefix">Caller id</template>
                </dads-select>
              </el-col>
            </div>

            <div class="inline-form-group">
              <el-col :span="12">
                <h3 class="form-section-header">Start Date / Time</h3>
              </el-col>
              <el-col :span="1" />
              <el-col :span="11">
                <h3 class="form-section-header">End Date / Time</h3>
              </el-col>
            </div>
            <div class="inline-form-group">
              <el-col :span="12">
                <el-date-picker
                  class="call-campaigns-datetimepicker"
                  v-model="startDateTime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  placeholder="Select start date and time"
                >
                </el-date-picker>
              </el-col>
              <el-col :span="1" />
              <el-col :span="11">
                <el-date-picker
                  class="call-campaigns-datetimepicker"
                  v-model="endDateTime"
                  type="datetime"
                  format="yyyy-MM-dd HH:mm"
                  placeholder="Select end date and time"
                />
              </el-col>
            </div>

            <div v-if="techType === 'sms'">
              <h3 class="form-section-header">Message</h3>
              <el-input
                v-model="form.message"
                placeholder="Message"
                type="textarea"
                :rows="3"
              />
            </div>

            <!-- Additional Fields for VOICE -->
            <div v-if="techType === 'voice'">


              <h2 class="form-section-header">
                Calling hours
              </h2>
              <div class="inline-form-group">
                <el-col :span="12">
                  <omnia-time-select
                    @onTimeSelected="voiceForm.callHoursStart = $event"
                    start="00:00"
                    end="23:59"
                    step="00:15"
                    title="Start time"
                  />
                </el-col>
                <el-col :span="1" />
                <el-col :span="11">
                  <omnia-time-select
                    @onTimeSelected="voiceForm.callHoursEnd= $event"
                    start="00:00"
                    end="23:59"
                    step="00:15"
                    title="End time"
                  />
                </el-col>
              </div>

              <el-input
                v-model="form.callFrequency"
                type="number"
                placeholder="Enter call frequency"
              >
                <template slot="prefix">
                  Call frequency
                </template>
              </el-input>
              <el-tag class="mb-1">
                <i class="el-icon-info"  style="margin-right: 4px;" />
                How many seconds to wait between calls
              </el-tag>


              <h2 class="form-section-header">When a call connects</h2>
              <el-checkbox
                v-model="enableVmDetect"
              >
                Enable voicemail detection
              </el-checkbox>

              <div v-if="enableVmDetect">
                <!-- ⭐ DESTINATION WHEN MATCHES ⭐ -->
                <h2 class="form-section-header">If voicemail detected</h2>
                <destination-selector
                  :isTerminalDestSelector="true"
                  :draggable="true"
                  :showHeader="false"
                  :draggableDestTypes="draggableDestTypes"
                :include-pharmacy-dests="true"
                  :selectedDestinations="voiceForm.matchDestinations"
                  @destinationsSelected="onMatchDestinationsSelection"
                  title=""
                  :clearFields="clearFormFields"
                />

                <!-- ⭐ DESTINATION WHEN NOT MATCHES ⭐ -->
                <h2 class="form-section-header">If person detected</h2>
                <destination-selector
                  :isTerminalDestSelector="true"
                  :draggable="true"
                  :showHeader="false"
                  :draggableDestTypes="draggableDestTypes"
                :include-pharmacy-dests="true"
                  :selectedDestinations="voiceForm.notMatchDestinations"
                  @destinationsSelected="onNotMatchDestinationsSelection"
                  title=""
                  :clearFields="clearFormFields"
                />
              </div>

              <destination-selector
                v-else
                :selectedDestinations="voiceForm.destinations"
                :showHeader="false"
                :draggableDestTypes="draggableDestTypes"
                :include-pharmacy-dests="true"
                :draggable="true"
                :isTerminalDestSelector="true"
                @destinationsSelected="onConnectDestinationsSelection"
                title=""
                :clearFields="clearFormFields"
              />
            </div>
          </el-tab-pane>

          <!-- MANAGE NUMBERS -->
          <el-tab-pane label="Manage Numbers" name="numbers">
            <div
              class="el-input el-input-group el-input-group--append el-input--prefix"
            >
              <input
                v-model="numberForm.number"
                type="text"
                autocomplete="off"
                placeholder="Enter number"
                class="el-input__inner"
                v-mask="'(###) ###-####'"
              />
              <span class="el-input__prefix">Number</span>
              <div class="el-input-group__append" v-if="numIsListed">
                Is Listed!
              </div>
            </div>
            <el-input
              class="text-area-input"
              placeholder="Enter description"
              v-model="numberForm.description"
            >
              <template slot="prefix">Description</template>
            </el-input>

            <!-- ADDITIONAL FILEDS for SMS -->
            <div v-if="techType === 'sms'">
              <h3 class="form-section-header">Additional Fields</h3>
              <draggable v-model="numberForm.fields">
                <transition-group name="list" tag="div">
                  <div
                    class="inline-form-group list-group-item"
                    v-for="(field, index) in numberForm.fields"
                    :key="`field-${index}`"
                  >
                    <el-col :span="12">
                      <el-input
                        v-model="field.value"
                        :placeholder="`Field ${index + 1}`"
                      >
                        <template slot="prefix"
                          >Field {{ index + 1 }}</template
                        ></el-input
                      ></el-col
                    >
                    <el-col :span="1" />
                    <el-col :span="4">
                      <el-button
                        class="table-action-button icon-blue"
                        icon="el-icon-rank"
                        style="width: 34px; height: 34px;"
                      />
                      <el-tooltip placement="top" content="Remove field">
                        <el-button
                          class="table-action-button icon-red"
                          icon="el-icon-delete"
                          style="width: 34px; height: 34px;"
                          @click="removeField(index)"
                        />
                      </el-tooltip>
                    </el-col>
                  </div>
                </transition-group>
              </draggable>
              <el-button
                type="default"
                icon="el-icon-circle-plus-outline"
                :disabled="disallowToAddFields"
                @click="addField"
                >Add a field</el-button
              >
            </div>

            <div class="inline-form-group" v-if="validNumber && !numIsListed">
              <el-col :span="11" />
              <el-col :span="5" />
              <el-col :span="8" style="text-align:right;">
                <el-tooltip content="Add number" placement="top">
                  <el-button type="primary" @click="addNumber">
                    <el-icon class="el-icon-plus" />
                  </el-button>
                </el-tooltip>
                <el-tooltip content="Reset" placement="top">
                  <el-button @click="clearNumberFields" type="danger">
                    <el-icon type="danger" class="el-icon-delete" /> </el-button
                ></el-tooltip>
              </el-col>
            </div>

            <h3 class="form-section-header">
              And / Or
            </h3>

            <div id="call-campaigns-numbers-block">
              <div class="inline-form-group mt-20">
                <bulk-example :filePath="techType === 'sms' ? smsBulkExampleFile  : voiceBulkExampleFile">
                  <el-button slot="hoverRef" type="primary" @click="startImport">
                    Import from csv
                  </el-button>
                </bulk-example>
                <el-button
                  class="ml-5"
                  type="danger"
                  icon="el-icon-close"
                  v-if="fileSelected"
                  @click="closeImporting"
                />
                <el-button
                  class="ml-5"
                  type="primary"
                  icon="el-icon-check"
                  v-if="csvReady"
                  @click="addToBulk"
                />
              </div>
              <div class="csv-import" v-show="importVisible">
                <upload-csv
                  ref="fileButton"
                  v-model="parsedCSV"
                  :key="uploadCSVKey"
                  :map-fields="mapFields"
                  @input="csvReady = true"
                  @invalidFileType="handleInvalidFileType"
                  @fileSelected="submitForMapping"
                  :headers="true"
                />
              </div>
            </div>

            <div v-if="bulkNumbers.length">
              <div class="inline-form-group">
                <el-col :span="12">
                  <el-input v-model="search" placeholder="Search" clearable />
                </el-col>
              </div>
              <div class="vxe-table">
                <vxe-grid
                  round
                  class="bulk-numbers-table"
                  border="inner"
                  height="350px"
                  auto-resize
                  show-overflow="title"
                  empty-text="No Data"
                  :scroll-y="{ enabled: true, gt: 50, oSize: 0 }"
                  :data="filteredBulkNumbers"
                  :columns="bulkTableColumns"
                />
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </el-form>
    </div>
  </el-dialog>
</template>

<script>
import moment from "moment";
import Draggable from "vuedraggable";

import uploadCSV from "@/components/upload-csv";
import bulkExample from "@/components/bulkExample";
import DadsSelect from "@/components/select";
import DestinationSelector from "@/components/DestinationSelector";
import OmniaTimeSelect from '@/components/OmniaTimeSelect';
import {phoneNumberFormatter} from "@/globals/globals";

export default {
  name: "CallCampaignsCreateForm",

  props: {
    createVisible: { required: true },
    techType: { required: true },
    phoneNumberOpts: { required: true },
    clearFormFields: { required: true },
    draggableDestTypes: { required: true },
    createProcessing: { required: true },
    timezoneOpts: { required: true },
    uploadCSVKey: { required: true }
  },

  components: {
    UploadCsv: uploadCSV,
    bulkExample,
    DadsSelect,
    DestinationSelector,
    Draggable,
    OmniaTimeSelect
  },

  data() {
    return {
      search: "",
      activeTabName: "general",

      startDateTime: moment().startOf("day"),
      endDateTime: moment().startOf("day"),
      stateOptions: ["READY", "PAUSED"],
      enableVmDetect: false,
      callingHours: [],

      form: {
        tenantId: null,
        name: "",
        callerId: "",
        dateStart: "",
        timeStart: "",
        dateEnd: "",
        timeEnd: "",
        message: "",
        timezone: "",
        state: "READY",
        callFrequency: ""
      },

      voiceForm: {
        recording: false,
        destinations: [],
        matchDestinations: [],
        notMatchDestinations: [],
        callHoursStart: '',
        callHoursEnd: ''
      },

      numberForm: { number: "", description: "", fields: [{ value: "" }] },

      // ⭐️ Bulk Data ⭐️ //
      bulkNumbers: [],
      parsedCSV: null,
      importVisible: false,
      csvReady: false,
      fileSelected: false,
      numIsListed: false,

      voiceBulkExampleFile:
        "https://global-app.s3.amazonaws.com/omnia-assets/bulk_call_campaign_numbers_example.csv",
      voiceTableColumns: [
        {
          width: 50,
          slots: {
            default: ({ rowIndex }) => {
              return [
                <div>
                  <el-tooltip content="Remove number" placement="top">
                    <el-button
                      onClick={() => this.removeFromBulk(rowIndex)}
                      class="table-action-button"
                      type="default"
                      icon="el-icon-minus"
                      size="mini"
                    />
                  </el-tooltip>
                </div>
              ];
            }
          }
        },
        { type: "seq", width: 40 },
        {
          field: "number",
          title: "Number",
          minWidth: "120",
          sortable: true,
          slots: {
            default: ({ row }) => {
              return [<span>{this.numberFormatter(row.number)}</span>];
            }
          }
        },
        {
          field: "description",
          title: "Description",
          minWidth: 100,
          sortable: true,
          showOverflow: true
        }
      ],
      voiceMapFields: [
        { label: "Number", key: "number" },
        { label: "Description", key: "description" }
      ],

      smsBulkExampleFile:
        "https://global-app.s3.amazonaws.com/omnia-assets/bulk_sms_campaign_numbers_example.csv",
      smsMapFields: [
        { label: "Number", key: "number" },
        { label: "Description", key: "description" }
      ],
      smsTableColumns: [
        {
          width: 50,
          slots: {
            default: ({ rowIndex }) => {
              return [
                <div>
                  <el-tooltip content="Remove number" placement="top">
                    <el-button
                      onClick={() => this.removeFromBulk(rowIndex)}
                      class="table-action-button"
                      type="default"
                      icon="el-icon-minus"
                      size="mini"
                    />
                  </el-tooltip>
                </div>
              ];
            }
          }
        },
        { type: "seq", width: 40 },
        {
          field: "number",
          title: "Number",
          minWidth: "120",
          sortable: true,
          slots: {
            default: ({ row }) => {
              return [<span>{this.numberFormatter(row.number)}</span>];
            }
          }
        },
        {
          field: "description",
          title: "Description",
          minWidth: 100,
          sortable: true,
          showOverflow: true
        }
      ]
    };
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },

    bulkExampleFile() {
      return this[`${this.techType}BulkExampleFile`];
    },

    mapFields() {
      return this[`${this.techType}MapFields`];
    },

    bulkTableColumns() {
      return this[`${this.techType}TableColumns`];
    },

    validNumber() {
      return (
        this.numberForm.number.length === 14 &&
        !this.numberForm.number.includes("_")
      );
    },

    filteredBulkNumbers() {
      return this.bulkNumbers.filter(
        data =>
          !this.search ||
          data.number.toLowerCase().includes(this.search.toLowerCase())
      );
    },

    number() {
      return this.numberForm.number;
    },

    disallowToAddFields() {
      return this.numberForm.fields.length >= 10;
    }
  },

  watch: {
    createVisible: {
      immediate: true,
      handler() {
        this.startDateTime = moment().startOf("day");
        this.endDateTime = moment().startOf("day");
      }
    },

    number(val) {
      const number = val.replace(/(\(|\)|-)/g, "");

      this.numIsListed = this.bulkNumbers
        .map(data => data.number)
        .includes(number);
    },

    startDateTime: {
      immediate: true,
      handler(val) {
        if (val) {
          const { date, time } = this.parseDateTime(val);
          this.form.dateStart = date;
          this.form.timeStart = time;
        }
      }
    },

    endDateTime: {
      immediate: true,
      handler(val) {
        if (val) {
          const { date, time } = this.parseDateTime(val);
          this.form.dateEnd = date;
          this.form.timeEnd = time;
        }
      }
    },

    clearFormFields: {
      immediate: true,
      handler(val) {
        if (val) {
          this.clearFields();
        }
      }
    }
  },

  methods: {
    // ⭐️ Additional Fields Methods for SMS ⭐️ //
    addField() {
      this.numberForm.fields.push({ value: "" });
    },

    removeField(index) {
      this.numberForm.fields.splice(index, 1);
      if (this.numberForm.fields.length === 0) {
        this.addField();
      }
    },

    onConnectDestinationsSelection(destinations) {
      this.voiceForm.destinations = [...destinations];
    },

    onMatchDestinationsSelection(destinations) {
      this.voiceForm.matchDestinations = [...destinations];
    },

    onNotMatchDestinationsSelection(destinations) {
      this.voiceForm.notMatchDestinations = [...destinations];
    },

    parseDateTime(dateObj) {
      const dateTime = moment(dateObj);
      const date = dateTime.format("YYYY-MM-DD");
      const time = dateTime.format("HH:mm");
      return { date, time };
    },

    numberFormatter(number) {
      if(number) {
        return phoneNumberFormatter(number);
      }

      return number;
    },

    remoteSearchPhoneNumbers(query) {
      this.$emit("remoteSearchPhoneNumbers", query);
    },

    addNumber() {
      const numberBody = { ...this.numberForm };
      let { number } = numberBody;
      numberBody.number = number.replace(/(-|\)|\(|\s)/g, "");

      const { fields } = numberBody;
      if (fields && fields.length) {
        delete numberBody.fields;

        if (this.techType === "sms") {
          if (fields && fields.length) {
            fields.forEach((field, index) => {
              numberBody[`field${index + 1}`] = field.value;
            });
          }
        }
      }

      this.bulkNumbers.push(numberBody);
      this.numberForm = {
        number: "",
        description: "",
        fields: [{ value: "" }]
      };
    },

    createOperation() {
      let createBody = {
        ...this.form,
        tech: this.techType.toUpperCase(),
        numbers: this.bulkNumbers.map(item => {
          delete item._XID;
          return item;
        })
      };

      createBody.tenantId = this.selectedTenant.id;
      createBody.timezone = createBody.timezone
        ? createBody.timezone
        : this.selectedTenant.timezone.name;

      if (this.techType === "voice") {
        const { recording, destinations, callHoursStart, callHoursEnd  } = this.voiceForm;
        createBody.recording = recording ? "yes" : "no";

        createBody.callHoursStart = callHoursStart;
        createBody.callHoursEnd = callHoursEnd;

        createBody.destinations = [];
        createBody.enableVMDetect = this.enableVmDetect;
        const checkVmDetectDests = this.enableVmDetect && (this.voiceForm.matchDestinations.filter(item => item.id).length === 0 || this.voiceForm.notMatchDestinations.filter(item => item.id).length === 0);
        const checkOnConnect = destinations.filter(item => item.id).length === 0 && !this.enableVmDetect;
        if ( checkOnConnect || checkVmDetectDests ) {
          this.$notify({
            title: "No Destination Selected!",
            message: "There is no destination set for when a call connects",
            type: "warning"
          })
        }
        destinations.forEach(({ id, type }) => {
          if (id && type) {
            createBody.destinations.push({ id, type });
          }
        });

        const matchDestinations = this.validateDestinations(
          this.voiceForm.matchDestinations,
          "MATCH"
        );
        const notMatchDestinations = this.validateDestinations(
          this.voiceForm.notMatchDestinations,
          "NOT-MATCH"
        );

        if(matchDestinations && notMatchDestinations) {
          createBody.matchDestinations = matchDestinations;
          createBody.notMatchDestinations = notMatchDestinations;
        }

      } else if (this.techType === "sms") {
        createBody.recording = "no";
      }

      this.$emit("createOperation", createBody);
    },

    cancelOperation() {
      this.$emit("cancelOperation", "create");
    },

    clearNumberFields() {
      this.numberForm = {
        number: "",
        description: "",
        fields: [{ value: "" }]
      };
    },

    clearFields() {
      this.search = "";
      this.activeTabName = "general";

      this.form = {
        name: "",
        callerId: "",
        dateStart: "",
        timeStart: "",
        dateEnd: "",
        timeEnd: "",
        message: "",
        timezone: "",
        state: "READY"
      };

      this.voiceForm = {
        recording: false,
        destinations: [],
        matchDestinations: [],
        notMatchDestinations: [],
        callHoursStart: '',
        callHoursEnd: ''
      };

      this.bulkNumbers = [];
      this.parsedCSV = null;
      this.importVisible = false;
      this.csvReady = false;
      this.fileSelected = false;
      this.numIsListed = false;
      this.enableVmDetect = false;

      this.clearNumberFields();
    },

    closeImporting() {
      this.parsedCSV = null;
      this.csvReady = false;
      this.fileSelected = false;
      this.importVisible = false;
      this.$refs.fileButton.sample = null;
      this.$refs.fileButton.fileSelected = false;
      this.$refs.fileButton.map = {};
      this.$refs.fileButton.isValidFileMimeType = false;
      this.$refs.fileButton.form = { csv: null };
      let fileButton = document.querySelector(".form-control-file");
      fileButton.value = null;
    },

    addToBulk() {
      const values = [...this.parsedCSV];
      for (let i = 0; i < values.length; i++) {
        let { number } = values[i];

        if (number) {
          number = number.replace(/(-|\)|\(|\s)/g, "");
          if (
            number.length === 10 &&
            !this.bulkNumbers.map(data => data.number).includes(number)
          ) {
            this.bulkNumbers.push({ ...values[i], number });
          }
        }
      }
      this.closeImporting();
    },

    startImport() {
      this.importVisible = true;
      const fileButton = document.querySelector(".form-control-file");
      fileButton.click();
    },

    removeFromBulk(index) {
      this.bulkNumbers.splice(index, 1);
    },

    submitForMapping() {
      this.fileSelected = true;
      this.$refs.fileButton.load();
    },

    handleInvalidFileType() {
      this.closeImporting();
      this.$notify({
        title: "Invalid file type",
        message: "Please import csv files only!",
        type: "error"
      });
    },

    validateDestinations(destinations, type) {
      if (destinations.length > 1 && destinations.find(dst => !dst.id)) {
        this.$notify({
          title: `Empty ${type} Destination field`,
          message: "Don't leave any destination field to be empty.",
          type: "error"
        });
        return;
      }

      let finalDestinations = [];
      if (destinations.length === 1 && destinations[0].id === null) {
        return finalDestinations;
      }

      if (destinations.length) {
        destinations.forEach((dst, idx) => (dst.order = idx + 1));

        finalDestinations = destinations.map(({ id, type, order }) => ({
          id,
          type,
          order
        }));
      }
      return finalDestinations;
    },
  },

  created() {
    this.startDateTime = moment().startOf("day");
    this.endDateTime = moment().startOf("day");
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/variables";

#call-campaigns-numbers-block {
  max-width: 600px;
  margin: 10px auto;
}

.vue-csv-uploader {
  input[type="file"] {
    display: none;
  }
}

.el-tabs {
  max-width: 600px;
  margin: 0 auto;
}

.el-checkbox {
  max-width: 600px;
  margin: 0 auto;
}
</style>
